import { graphql } from '~publish/graphql'

import { useTypedMutation } from '../../hooks/useTypedMutation'

export const MovePostToDrafts = graphql(/* GraphQL */ `
  mutation MovePostToDrafts($id: PostId!) {
    movePostToDraftsV2(input: { id: $id }) {
      __typename
      ... on MutationError {
        message
      }
      ... on PostActionSuccess {
        post {
          id
          status
          dueAt
        }
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useMovePostToDrafts = () =>
  useTypedMutation(MovePostToDrafts, (data) => data.movePostToDraftsV2, {
    refetchQueries: ['GetPostList'],
    successTypename: 'PostActionSuccess',
  })
